// extracted by mini-css-extract-plugin
export var container = "_10-0";
export var icon = "_10-1";